import { useMemo } from "react"
import PropTypes from "prop-types"
import { Button, Tooltip } from "@mui/material"

export default function SaveButton({ saveSelectedMetrics, canSaveView, isEditing, isSaving = false }) {
  const disabledButtonMessage = "Your view must have a valid name in order to save."

  const saveButton = useMemo(() => {
    return <Button color="primary" onClick={saveSelectedMetrics} disabled={!canSaveView || isSaving}>
      {isSaving ? "Saving..." : `${isEditing ? "Update" : "Create"} Custom View`}
    </Button>
  }, [canSaveView, isEditing, saveSelectedMetrics, isSaving])

  if (canSaveView) {
    return saveButton
  }

  return <Tooltip title={disabledButtonMessage}>
    <span>{saveButton}</span>
  </Tooltip>
}

SaveButton.propTypes = {
  saveSelectedMetrics: PropTypes.func.isRequired,
  canSaveView: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
}
